import ListGroup from 'react-bootstrap/ListGroup';

const edu = [
  {
    date: 'December 2020 - Present',
    degree: 'Bachelor of Science - BS in Computer Science in Computer Science',
    school: 'Colorado State University, Global Campus at Aurora, Colorado',
    id: 1
  },
  {
    date: 'August 2015 - May 2019',
    degree: `Bachelor of Science - BS in Computer Science in Computer Science, Information Systems, &
    Cyber Security`,
    school: 'Elmhurst University at Elmhurst, Illinois',
    id: 2
  }
];

const items = edu.map(edu =>
  <ListGroup.Item key={edu.id}>
    <small>{edu.date}</small>
    <p>{edu.school}</p>
    <p>{edu.degree}</p>
  </ListGroup.Item>
);

function Education() {
  return (
    <div>
      <h2>Education</h2>
      <ListGroup variant='flush'>
        {items}
      </ListGroup>
    </div>
  );
}

export default Education;
